import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { AddCircleBlue, CustomDelete, FullTable } from 'components';
import { Images, PermissionList, RolePermission, sortListByKey, useModal } from 'utils';
import { domainActions } from 'store';
import { ACTION_TYPE, domainHead, domainBody, domainNotYet } from './constants';
import { AddDomain } from './addDomain';
import { useLocation } from 'react-router-dom';

const DELETE_ACTION_TYPE = 'DELETE_CLIENT_CONTACT';

export const Domains = ({}) => {
    const domainList = useSelector((state) => state.domains.domainList);
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();

    useEffect(() => {
        getDomains();
    }, [dispatch, info]);

    const getDomains = (load) => {
        const pushInfo = {
            ...info,
            clientId: params?.id,
        };
        delete pushInfo.page;
        delete pushInfo.activeTab;
        dispatch(domainActions.getDomains(pushInfo, load));
    };

    const handleClickButton = (item, name) => {
        if (name === 'editDomain') {
            open(<AddDomain info={item} afterSuccess={() => getDomains('noLoad')} />);
        } else if (name === 'deleteDomain') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete the domain? This action cannot be undone."
                    info="Delete Domain"
                    handleDel={() => dispatch(domainActions.deleteDomain(item?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    afterSuccess={() => getDomains('noLoad')}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.layer} alt="icon" />
                            <p>{item?.name}</p>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <div>
            {RolePermission([PermissionList.DOMAIN_CREATE?.code]) && (
                <div className="header-action-btn">
                    <AddCircleBlue text={'Add Domain'} handleClick={() => open(<AddDomain afterSuccess={() => getDomains('noLoad')} />)} />
                </div>
            )}
            <FullTable
                head={domainHead}
                body={domainBody}
                loadingType={ACTION_TYPE}
                list={sortListByKey(domainList, 'name')}
                handleClickButton={handleClickButton}
                notYet={domainNotYet}
                margin={'0'}
            />
        </div>
    );
};
